'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Api = require('../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _SignUp = require('./SignUp');

var _SignUp2 = _interopRequireDefault(_SignUp);

var _ForgotPassword = require('./ForgotPassword');

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _LinkUser = require('./LinkUser');

var _LinkUser2 = _interopRequireDefault(_LinkUser);

var _SimpleButton = require('../generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _UserProfile = require('../account/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _FontAwesome = require('../common/FontAwesome');

var _FontAwesome2 = _interopRequireDefault(_FontAwesome);

var _Spinner = require('../generic/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var SIGN_UP_TITLE = "Please Sign Up";
var SIGN_IN_TITLE = "Please Sign In";
var UPDATE_CONTACT_TITLE = "Please update phone number";
var LINK_ACCOUNT_TITLE = "Link existing account";
var SIGN_IN_INCORRECT_DET = "Incorrect username or password.";
var REQ_FIELD_ERROR = "Please enter username & password.";
var FORGOT_PASSWORD = "Forgot Password?";
var RESET_PASSWORD = "Reset Password";
var LOGIN_BUTTON_TEXT = "Sign in with FreshBytes";
var LOGIN_BUTTON_SPIN_TEXT = "Please wait...";
var SIGN_UP_BUTTON_TEXT = "Sign Up";
var googleUser = {};
var isSignInAttached = false;
var UPDATE_PROFILE = "Update Profile";
var ERROR_MESSAGE_FOR_EMAIL = "Could not retrieve email address from Facebook. Please try again.";
var ERROR_MESSAGE_FROM_GOOGLE = "Could not retrieve email address from Gmail. Please try again.";
var AUTH_URL = "https://www.googleapis.com/oauth2/v3/userinfo";

// Create a google auth provider
var provider = {
    authenticate: function authenticate(options) {
        if (options.success) {
            options.success(this, {});
        }
    },
    restoreAuthentication: function restoreAuthentication(authData) {},
    getAuthType: function getAuthType() {
        return 'google';
    },
    deauthenticate: function deauthenticate() {}
};

window.p = _parse2.default;
window.provider = provider;

var LoginForm = (0, _createReactClass2.default)({
    displayName: 'LoginForm',
    getInitialState: function getInitialState() {
        return {
            error: null,
            linkError: null,
            isPhoneNumberRequired: true,
            view: {
                isLoginBoxActive: true,
                isSignupBoxActive: false,
                isForgotPasswordBoxActive: false,
                isLinkUserAccountBoxActive: false,
                isCaptureUserPhoneBoxActive: false
            }
        };
    },
    componentDidMount: function componentDidMount() {

        var orderType = _CartStore2.default.getOrderType();

        if (_MainStore2.default.isLocationForDineInOnly() || orderType == "DineIn") {
            var askPhone = _CartStore2.default.isDineInPhoneRequired();
            this.setState({ isPhoneNumberRequired: askPhone });
        }
    },
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
        if (this.props.changeModalTitle) {
            this.props.changeModalTitle(SIGN_IN_TITLE);
        }
    },
    userAction: function userAction(token) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var self, response, myJson;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            Utils.showSpinner();

                            self = _this;
                            _context.next = 4;
                            return fetch(AUTH_URL, {
                                method: 'GET',
                                headers: { Authorization: 'Bearer ' + token }
                            });

                        case 4:
                            response = _context.sent;
                            _context.next = 7;
                            return response.json();

                        case 7:
                            myJson = _context.sent;
                            //extract userInfo JSON from the http response
                            self.handleCallBackResponse(myJson, token);

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    handleCallBackResponse: function handleCallBackResponse(responsePayload, accessToken) {
        var self = this;
        var router = this.props.history;
        var locId = this.props.locId;

        if (!Utils.isEmptyObj(responsePayload) && !Utils.isEmpty(responsePayload.email)) {
            //user id returned after authentication
            var id = responsePayload.sub;

            //access token used for authorization
            var idToken = accessToken;

            var authDataWrapper = {
                authData: {
                    id: id,
                    access_token: idToken
                    // expiration_date : "2022-12-07T05:56:42.000Z"
                    //earlier we were using expiration date.
                    //but now we dont need expiration date now.
                }
            };

            _parse2.default.User.logInWith(provider, authDataWrapper).then(function (user) {
                // Update the user ACL Account
                return Utils.updateUserAcl(user);
            }).then(function (user) {

                // check user object
                if (!Utils.isEmptyObj(user)) {
                    // Update the user details in parse
                    self.updateNewGoogleUser(user, responsePayload);
                } else {
                    self.setState({
                        error: "Some error occurred while loggging in! Try again."
                    });
                    Utils.hideSpinner();

                    // logout user account if logged in
                    Utils.logOutAll(router, locId, false);
                }
            }, function (error) {
                console.log(JSON.stringify(error));
                self.setState({
                    error: "Some error occurred while loggging in! " + error
                });
                Utils.hideSpinner();

                // logout user account if logged in
                Utils.logOutAll(router, locId, false);
            });
        } else {
            Utils.hideSpinner();
            // If we did not receive the email address from google.
            console.log(responsePayload);
            self.setState({
                error: ERROR_MESSAGE_FROM_GOOGLE
            });
            // logout user account if logged in
            Utils.logOutAll(router, locId, false);
        }
    },
    attachSignIn: function attachSignIn() {

        var self = this;
        var client = google.accounts.oauth2.initTokenClient({
            client_id: GOOGLE_CLIENT_ID + '.apps.googleusercontent.com',
            scope: 'profile email',
            callback: function callback(tokenResponse) {
                if (tokenResponse && tokenResponse.access_token) {
                    self.userAction(tokenResponse.access_token);
                } else {
                    // Utils.hideSpinner();
                    console.log("Did not receive the access token");
                }
            }
        });

        client.requestAccessToken();
    },
    updateNewGoogleUser: function updateNewGoogleUser(parseUser, googleUser) {

        var self = this;
        //userDate from google oAuth.
        var username = googleUser.email;
        var name = googleUser.name;
        var firstname = googleUser.given_name;
        var lastname = googleUser.family_name;
        var profilePicture = googleUser.picture;

        parseUser.set("username", username);
        parseUser.set("firstname", firstname);
        parseUser.set("lastname", lastname);
        parseUser.set("name", name);
        parseUser.set("email", username);

        var defaultUserPhoneActive = false;
        if (!parseUser.get("phoneNumber")) {

            defaultUserPhoneActive = true;
            if (!self.state.isPhoneNumberRequired) {
                defaultUserPhoneActive = false;
                parseUser.set("phoneNumber", "0000000000");
            }
        }

        parseUser.save().then(function (user) {
            if (self.props.callbackParent != null) {
                // self.props.callbackParent(true, self.props.enableProfileEdit);
                self.props.callbackParent(true, defaultUserPhoneActive);
            }
            _Actions2.default.informLoginChange(user);

            Utils.hideSpinner();
        }, function (error) {
            if (self.props.changeModalTitle) {
                self.props.changeModalTitle(LINK_ACCOUNT_TITLE);
            }

            var errorMessage = error.message;

            if (error.code == "202") {
                errorMessage = 'There is already an account with email "' + username + '".\n                             Enter your password to connect it with your Google account.\n                              You\'ll only need to do this once.\n                             If you forgot password, use "forgot password" option to retrieve it.';
            }

            Utils.hideSpinner();

            self.setState({
                linkError: errorMessage,
                userFromAuthProviderLogin: parseUser,
                userPic: profilePicture,
                authType: "google",
                view: {
                    isLinkUserAccountBoxActive: true,
                    isLoginBoxActive: false
                }
            });
        });
    },
    handleFBLogin: function handleFBLogin() {
        var self = this;
        Utils.showSpinner();

        // parse function
        _parse2.default.FacebookUtils.logIn("public_profile,email", {
            success: function success(parseUser) {
                // update the user ACL
                if (!parseUser.existed()) {
                    // for new user
                    Utils.updateUserAcl(parseUser);
                    self.updateFacebookUser(parseUser);
                } else {
                    // for existing user
                    // check if the email is exist
                    if (parseUser.get("email") && parseUser.get("name")) {
                        self.afterFBLoginSuccess(parseUser);
                    } else {
                        // update all the details again
                        self.updateFacebookUser(parseUser);
                    }
                }
            },
            error: function error(user, _error) {
                console.log("User cancelled the Facebook login or did not fully authorize." + _error + user);
                console.log("Login-form:" + JSON.stringify(user));
                self.setState({
                    error: "User cancelled the Facebook login or did not fully authorize !"
                });
                Utils.hideSpinner();
            }
        });
    },
    updateFacebookUser: function updateFacebookUser(parseUser) {

        var self = this;

        FB.api('/me', 'GET', { "fields": "id,name,first_name,last_name,email,picture" }, function (response) {

            // if email exist then go forward otherwise showing the warning
            if (!Utils.isEmpty(response.email)) {

                parseUser.set("username", response.email);
                parseUser.set("firstname", response.first_name);
                parseUser.set("lastname", response.last_name);
                parseUser.set("name", response.name);
                parseUser.set("email", response.email);

                if (!parseUser.get("phoneNumber") && !self.state.isPhoneNumberRequired) {
                    parseUser.set("phoneNumber", "0000000000");
                }

                parseUser.save().then(function (user) {

                    self.afterFBLoginSuccess(user);
                }, function (error) {

                    if (self.props.changeModalTitle) {
                        self.props.changeModalTitle(LINK_ACCOUNT_TITLE);
                    }

                    var errorMessage = error.message;

                    if (error.code == "202") {
                        //self.logOut();
                        errorMessage = 'There is already an account with email "' + response.email + '".\n                                            Enter your password to connect it with your Facebook account.\n                                            You\'ll only need to do this once.\n                                            If you forgot password, use "forgot password" option to retrieve it.';
                    }

                    Utils.hideSpinner();

                    self.setState({
                        linkError: errorMessage,
                        userFromAuthProviderLogin: parseUser,
                        userPic: response.picture.data.url,
                        authType: "facebook",
                        view: {
                            isLinkUserAccountBoxActive: true,
                            isLoginBoxActive: false
                        }
                    });
                });
            } else {
                // if user do not share the email address
                // Remove app from user account
                FB.api("/" + response.id + "/permissions", "delete", function (response) {
                    console.log(response); //gives true on app delete success
                });

                var router = this.props.history;
                var locId = this.props.locId;

                Utils.hideSpinner();
                // logout user account if logged in
                Utils.logOutAll(router, locId, false);
                // Show error message to user
                self.setState({
                    error: ERROR_MESSAGE_FOR_EMAIL
                });
            }
        });
    },
    afterFBLoginSuccess: function afterFBLoginSuccess(parseUser) {

        var self = this;

        var defaultUserPhoneActive = false;
        if (!parseUser.get("phoneNumber") && self.state.isPhoneNumberRequired) {
            defaultUserPhoneActive = true;
        }

        // update the title of modal
        if (self.props.changeModalTitle) {
            self.props.changeModalTitle(UPDATE_PROFILE);
        }
        // Show the update profile modal
        self.setState({
            userFromAuthProviderLogin: parseUser,
            authType: "facebook",
            view: {
                isCaptureUserPhoneBoxActive: defaultUserPhoneActive,
                isLoginBoxActive: false
            }
        });

        if (self.props.callbackParent != null) {
            self.props.callbackParent(true, defaultUserPhoneActive);
        }

        _Actions2.default.informLoginChange(parseUser);

        Utils.hideSpinner();
    },
    informUserLinkStatusChange: function informUserLinkStatusChange(linkedUser) {
        this.setState({
            view: {
                isLinkUserAccountBoxActive: false,
                userFromAuthProviderLogin: null,
                authType: null
            }
        });

        this.informUserStatusChange(linkedUser);
    },
    informUserPhoneUpdate: function informUserPhoneUpdate(currentUser) {
        this.setState({
            view: {
                isCaptureUserPhoneBoxActive: false
            }
        });

        this.informUserStatusChange(currentUser);
    },
    informUserStatusChange: function informUserStatusChange(currentUser) {
        if (currentUser) {
            if (this.props.callbackParent != null) {
                this.props.callbackParent(true);
            }
            _Actions2.default.informLoginChange(currentUser);
        }
    },
    showSignupBox: function showSignupBox() {
        this.setState({
            view: {
                isLoginBoxActive: false,
                isSignupBoxActive: true,
                isForgotPasswordBoxActive: false,
                isLinkUserAccountBoxActive: false,
                isCaptureUserPhoneBoxActive: false
            }
        });

        this.props.changeModalTitle(SIGN_UP_TITLE);
    },
    showLoginBox: function showLoginBox() {
        this.setState({
            view: {
                isLoginBoxActive: true,
                isSignupBoxActive: false,
                isForgotPasswordBoxActive: false,
                isLinkUserAccountBoxActive: false,
                isCaptureUserPhoneBoxActive: false
            }
        });

        this.props.changeModalTitle(SIGN_IN_TITLE);
    },
    showForgotPasswordBox: function showForgotPasswordBox() {
        this.setState({
            view: {
                isLoginBoxActive: false,
                isSignupBoxActive: false,
                isForgotPasswordBoxActive: true,
                isLinkUserAccountBoxActive: false,
                isCaptureUserPhoneBoxActive: false
            }
        });

        this.props.changeModalTitle(FORGOT_PASSWORD);
    },
    submit: function submit(e) {
        e.preventDefault();

        var self = this;
        self.setState({
            error: null
        });

        var username = this.refs.lusername.value;
        var password = this.refs.lpassword.value;

        if (username.length && password.length) {
            Utils.showSpinner();

            _parse2.default.User.logIn(username, password).then(function (currentUser) {
                Utils.updateUserAcl();
                Utils.hideSpinner();
                self.setState({
                    error: null
                });
                if (self.props.callbackParent != null) {
                    self.props.callbackParent(true);
                }
                _Actions2.default.informLoginChange(currentUser);
            }, function () {
                self.setState({
                    error: SIGN_IN_INCORRECT_DET
                }, function () {
                    Utils.hideSpinner();
                });
            });
        } else {
            this.setState({
                error: REQ_FIELD_ERROR
            });
        }
    },
    keyDown: function keyDown(e) {
        if (e.keyCode === 13) {
            this.submit(e);
        }
    },
    handleChange: function handleChange() {
        this.setState({
            error: ""
        });
    },
    render: function render() {

        var logoCommonStyle = {
            maxWidth: '50%',
            height: 'auto',
            maxHeight: '100px',
            marginBottom: 10
        };

        return _react2.default.createElement(
            'div',
            { className: 'container-fluid bg-white mb-2 py-3 mt-n3 mb-n2' },
            _react2.default.createElement(_Spinner2.default, null),
            this.state.view.isLoginBoxActive ? _react2.default.createElement(
                'div',
                { className: "row" },
                _react2.default.createElement(
                    'div',
                    { className: "col-md-12 col-lg-12" },
                    _react2.default.createElement(
                        'div',
                        { className: 'login d-flex align-items-center py-2' },
                        _react2.default.createElement(
                            'div',
                            { className: "container" },
                            _react2.default.createElement(
                                'div',
                                { className: "row" },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-12 col-lg-12 mx-auto no-gutter py-2' },
                                    _react2.default.createElement(
                                        'form',
                                        { id: 'loginform', className: 'form-horizontal',
                                            onKeyDown: this.keyDown, onSubmit: this.submit, role: 'form' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group mb-2' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'inputEmail', className: 'mb-1' },
                                                'Email address'
                                            ),
                                            _react2.default.createElement('input', { type: 'email', id: 'login-username',
                                                name: 'username', placeholder: 'Email address',
                                                ref: 'lusername',
                                                className: "rounded-sm" + " form-control",
                                                onChange: this.handleChange
                                            })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group mb-1' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'inputPassword', className: 'mb-1' },
                                                'Password'
                                            ),
                                            _react2.default.createElement('input', { type: 'password', id: 'login-password',
                                                name: 'password', placeholder: 'Password',
                                                ref: 'lpassword',
                                                className: "rounded-sm form-control",
                                                onChange: this.handleChange
                                            })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'mb-3 checkbox-div' },
                                            _react2.default.createElement(
                                                'label',
                                                {
                                                    className: 'container-checkbox pull-left chk-lbl' },
                                                _react2.default.createElement(
                                                    'span',
                                                    { className: "ft-13" },
                                                    'Remember password'
                                                ),
                                                _react2.default.createElement('input', {
                                                    name: 'remember', type: 'checkbox',
                                                    id: 'login-remember',
                                                    className: 'custom-control-input'
                                                }),
                                                _react2.default.createElement('span', { className: 'checkmark' })
                                            ),
                                            _react2.default.createElement('span', { className: 'clearfix' })
                                        ),
                                        !Utils.isEmpty(this.state.error) ? _react2.default.createElement(
                                            'div',
                                            { id: 'login-alert',
                                                className: 'alert alert-danger col-sm-12' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'row centered errors',
                                                    style: { marginLeft: 5 } },
                                                _react2.default.createElement('i', { className: 'glyphicon glyphicon-remove' }),
                                                ' ',
                                                this.state.error
                                            )
                                        ) : null,
                                        _react2.default.createElement(
                                            'button',
                                            {
                                                className: "btn btn-lg" + " rounded-sm" + " custom-btn-outline-primary btn-block btn-login text-uppercase font-weight-bold mb-2",
                                                onClick: this.submit },
                                            'Sign in'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'text-center pt-3' },
                                        _react2.default.createElement(
                                            'a',
                                            { onClick: this.showSignupBox, className: 'cursor-pointer' },
                                            'Don\u2019t have an account? ',
                                            _react2.default.createElement(
                                                'span',
                                                {
                                                    className: 'text-danger' },
                                                ' Sign Up'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'text-center pt-1' },
                                        _react2.default.createElement(
                                            'a',
                                            { onClick: this.showForgotPasswordBox, className: 'cursor-pointer' },
                                            'Forgot password?'
                                        )
                                    ),
                                    _react2.default.createElement('hr', { className: 'my-4' }),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'text-center' },
                                        'LOGIN WITH'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'row' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'col pr-2' },
                                            _react2.default.createElement(
                                                'button',
                                                {
                                                    className: 'btn pl-1 pr-1 btn-lg btn-danger rounded-sm font-weight-normal text-white btn-block text-uppercase',
                                                    type: 'submit', id: 'customBtn',
                                                    onClick: this.attachSignIn },
                                                _react2.default.createElement(_FontAwesome2.default, {
                                                    icon: 'google', className: 'mr-2' }),
                                                ' Google'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'col pl-2' },
                                            _react2.default.createElement(
                                                'button',
                                                {
                                                    className: 'btn pl-1 pr-1 btn-lg rounded-sm btn-facebook font-weight-normal text-white btn-block text-uppercase',
                                                    type: 'submit', id: 'btn-social-login',
                                                    onClick: this.handleFBLogin },
                                                _react2.default.createElement(_FontAwesome2.default, {
                                                    icon: 'facebook', className: 'mr-2' }),
                                                ' Facebook'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ) : null,
            this.state.view.isCaptureUserPhoneBoxActive ? _react2.default.createElement(
                'div',
                { className: "col-lg-12" },
                _react2.default.createElement(_UserProfile2.default, {
                    callbackParent: this.props.callbackParent,
                    informUserUpdate: this.informUserPhoneUpdate,
                    history: this.props.history,
                    locId: this.props.locId
                })
            ) : null,
            this.state.view.isForgotPasswordBoxActive ? _react2.default.createElement(_ForgotPassword2.default, {
                logoCommonStyle: logoCommonStyle,
                logo: this.props.logo,
                showLoginBox: this.showLoginBox,
                showSignupBox: this.showSignupBox
            }) : null,
            this.state.view.isSignupBoxActive ? _react2.default.createElement(_SignUp2.default, {
                logoCommonStyle: logoCommonStyle,
                logo: this.props.logo,
                showLoginBox: this.showLoginBox,
                informSignUpStatus: this.informUserStatusChange
            }) : null,
            this.state.view.isLinkUserAccountBoxActive ? _react2.default.createElement(_LinkUser2.default, {
                callbackParent: this.props.callbackParent,
                showForgotPasswordBox: this.showForgotPasswordBox,
                showLoginBox: this.showLoginBox,
                informLinkStatus: this.informUserLinkStatusChange,
                userFromAuthProviderLogin: this.state.userFromAuthProviderLogin,
                authType: this.state.authType,
                userPic: this.state.userPic,
                message: this.state.linkError,
                history: this.props.history,
                locId: this.props.locId
            }) : null
        );
    }
});
exports.default = LoginForm;


//////////////////
// WEBPACK FOOTER
// ./src/components/login/LoginForm.jsx
// module id = 536
// module chunks = 0